import {
  Stack,
  Button,
  Box,
  ClickAwayListener,
  Divider,
  Typography,
  TextField,
} from "@mui/material";
import { toast } from "material-react-toastify";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useParams } from "react-router";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import { djangoHandleDataRequests } from "../../../../api";
import ShopWrapper from "../ShopWrapper";
import moment from "moment";
import { DateRange } from "react-date-range";
import { SecondaryButton } from "../../../../Utils/ButtonHelper";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from "react-redux";
import ReportsLoader from "../../../../Utils/ReportsLoader";

const styles = {
  position: "absolute",
  top: 28,
  right: 0,
  left: 10,
  zIndex: 100,
  p: 1,
  width: "fit-content",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
};

const DaywiseItemSummaryReport = ({ data }) => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;

  // getting the hotel currency
  const hotelCurrency = data?.accessControl?.hotel?.hotel_currency;

  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  const { shopId } = useParams();

  // Getting the start date as well as the end date to load the data
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // Get All report data
  const [reportsData, setreportsData] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  //Function to get report data
  const fetchData = () => {
    setreportsData(null);
    shopId &&
      djangoHandleDataRequests(
        `pos/daywise-item-sales-summary-report/?shop_id=${shopId}&start_date=${moment(
          dateRange[0].startDate
        ).format("YYYY-MM-DD 00:00:00")}&end_date=${moment(
          dateRange[0].endDate
        ).format("YYYY-MM-DD 23:59:59")}`
      )
        .then((res) => {
          setreportsData(res);
        })
        .catch((err) =>
          toast.error("Error in getting  data! Please try again later.")
        );
  };

  //open and close date picker
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen((prev) => !prev);
  const handleClickAway = () => {
    setOpen(false);
  };

  console.log("reports data : ", reportsData);

  // Report columns
  const columns = [
    {
      dataField: "shop_name",
      text: "Shop name",
    },
    {
      dataField: "date",
      text: "Date",
    },
    {
      dataField: "product_name",
      text: "Item name",
    },
    {
      dataField: "avg_product_price",
      text: `Avg. item price (${hotelCurrency})`,
    },
    {
      dataField: "total_quantity",
      text: `Total qty`,
      // sort: true,
    },
    {
      dataField: "total_sub_total",
      text: `Total subtotal`,
    },
    {
      dataField: "total_discount",
      text: `Total discount (${hotelCurrency})`,
    },
    {
      dataField: "total_tax",
      text: `Total tax (${hotelCurrency})`,
    },
    {
      dataField: "total_amount",
      text: `Total (${hotelCurrency})`,
    },
  ];

  return (
    <ShopWrapper
      backBtn={true}
      contentArea={
        <>
          <h1 className="mt-3 mb-3">Daywise item sales summary report</h1>
          <Divider className="mt-2 mb-2" />
          {reportsData ? (
            <div className="App">
              {/* {reportsColumns.length > 0 && ( */}
              <ToolkitProvider
                keyField="id"
                data={reportsData}
                columns={columns}
                exportCSV
                search
                noDataIndication="No data found"
              >
                {(props) => (
                  <>
                    <Stack
                      direction="row"
                      className="position-relative w-100 justify-content-between mt-4"
                      style={{ marginTop: "auto", marginBottom: "auto" }}
                    >
                      <Stack
                        className="position-relative w-50"
                        direction="row"
                        spacing={2}
                      >
                        <SearchBar
                          {...props.searchProps}
                          style={{
                            marginTop: "auto",
                            marginBottom: "auto",
                          }}
                        />
                        <Stack spacing={4} className="position-relative">
                          <ClickAwayListener onClickAway={handleClickAway}>
                            <Box sx={{ position: "relative" }}>
                              <button
                                onClick={handleClick}
                                className="border border-1 rounded p-2"
                                style={{
                                  backgroundColor: "transparent",
                                  height: "37.5px",
                                }}
                              >
                                {moment(dateRange[0].startDate).format(
                                  "DD MMM YYYY"
                                )}{" "}
                                {" to "}
                                {moment(dateRange[0].endDate).format(
                                  "DD MMM YYYY"
                                )}
                              </button>
                              {open ? (
                                <Box sx={styles}>
                                  <Stack spacing={3}>
                                    <DateRange
                                      editableDateInputs={true}
                                      onChange={(item) =>
                                        setDateRange([item.selection])
                                      }
                                      moveRangeOnFirstSelection={false}
                                      ranges={dateRange}
                                    />
                                    <Stack
                                      className="position-relative w-100 d-flex justify-content-between"
                                      direction="row"
                                    >
                                      <SecondaryButton
                                        text="Cancel"
                                        onClick={() => setOpen(false)}
                                      />
                                      <Button
                                        variant="custom-button"
                                        onClick={() => {
                                          fetchData();
                                          handleClickAway();
                                        }}
                                      >
                                        Apply
                                      </Button>
                                    </Stack>
                                  </Stack>
                                </Box>
                              ) : null}
                            </Box>
                          </ClickAwayListener>
                        </Stack>
                      </Stack>
                      <ExportCSVButton
                        {...props.csvProps}
                        style={{
                          display: "block",
                          background: "black",
                          color: "white",
                          marginTop: -1.5,
                          marginBottom: "auto",
                          marginLeft: "auto",
                        }}
                      >
                        Export CSV
                      </ExportCSVButton>
                    </Stack>
                    <Stack className="mt-4">
                      {reportsData.length > 0 ? (
                        <BootstrapTable
                          pagination={paginationFactory({ sizePerPage: 10 })}
                          {...props.baseProps}
                        />
                      ) : (
                        <Typography
                          className="position-relative mt-8 text-align-center"
                          style={{
                            fontSize: "15px",
                            marginTop: "15px",
                            color: "grey",
                            textAlign: "center",
                          }}
                        >
                          No data found!
                        </Typography>
                      )}
                    </Stack>
                  </>
                )}
              </ToolkitProvider>
              {/* )} */}
            </div>
          ) : (
            <ReportsLoader />
          )}
        </>
      }
    />
  );
};

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(DaywiseItemSummaryReport);
